<template>
    <div class="flex items-center justify-center w-full h-full border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-800 dark:border-gray-700 p-8" :class="{'min-h-screen min-w-screen': !isCompact}">
        <div role="status">
            <IconLoading class="w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"/>
        </div>
    </div>
</template>

<script>
    import IconLoading from "@/components/Icon/IconLoading.vue";

    export default {
        name: "LoadingComponent",
        components: {IconLoading},
        props: {
            isCompact: {
                type: Boolean,
                default: false,
            }
        }
    }
</script>